import type { CSSProperties } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useAutoScaler } from '../../hooks/useAutoScaler';
import '../../styles/aida-base.css';
import '../../styles/aida-responsive.css';
import { legalButtonBase, legalTitleStyle, PURPLE_NEBULA } from './legal/legalPageStyles';

const bodyText: CSSProperties = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '26px',
  color: 'rgba(255, 255, 255, 0.9)',
  margin: 0,
};

export const NotFound = () => {
  const { isContentReady } = useAutoScaler();

  return (
    <>
      <Helmet>
        <title>Page not found | Playcast</title>
        <meta name='description' content="Oops — we can't find that page." />
      </Helmet>

      <div className='w-full' style={{ backgroundColor: 'black', margin: 0, padding: 0, width: '100%', overflow: 'hidden' }}>
        <div style={{ paddingTop: '60px', display: 'flex', justifyContent: 'center', margin: 0, padding: 0 }}>
          <div
            id='auto-scaler'
            style={{
              width: '1024px',
              transformOrigin: 'top center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: 0,
              padding: 0,
              overflow: 'visible',
              opacity: isContentReady ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
            }}
          >
            <div style={{ width: '100%', ...PURPLE_NEBULA, minHeight: '100vh' }}>
              <div className='px-4 pb-48 pt-[72px] lg:px-36 lg:pb-60 lg:pt-[120px]' style={{ width: '100%' }}>
                <div
                  data-testid='not-found-page'
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    textAlign: 'center',
                  }}
                >
                  <img
                    src='/img/aida/not-found.png'
                    alt='Work in progress illustration'
                    className='fixMobileImageStretch mb-6 block h-auto w-full max-w-[280px] object-contain lg:max-w-[555px]'
                    data-testid='not-found-illustration'
                    style={{ objectPosition: 'center' }}
                  />
                  <h1
                    className='mb-4 max-w-[320px] text-center text-[48px] leading-[54px] lg:max-w-none lg:text-[28px] lg:leading-[36px]'
                    style={legalTitleStyle}
                  >
                    Oops —
                    <br className='lg:hidden' /> we can&apos;t find that page.
                  </h1>
                  <p className='mb-7 max-w-[320px] lg:max-w-none' style={bodyText}>
                    Looks like that link wandered off. Let&apos;s get you back home.
                  </p>
                  <Link
                    to='/'
                    data-testid='not-found-home-link'
                    className='aida-button'
                    style={{ ...legalButtonBase, fontSize: '13px', padding: '8px 20px', background: '#FBBF24', color: '#161423' }}
                  >
                    <span className='text'>Check out Playcast</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
